import React, { useEffect, useRef, useState } from "react";
import {
  clampPolygonExpansion,
  MAX_POLYGON_EXPANSION_METERS,
  POLYGON_EXPANSION_STEP_METERS,
} from "../Map/utils/polygonExpansion";

export default function PolygonExpansionControl({ value = 0, onChange, disabled = false }) {
  const [localValue, setLocalValue] = useState(value);
  const timer = useRef(null);
  useEffect(() => {
    clearTimeout(timer.current);
    setLocalValue(value);
    return () => clearTimeout(timer.current);
  }, [value]);

  const update = (next) => {
    const meters = clampPolygonExpansion(next);
    setLocalValue(meters);
    clearTimeout(timer.current);
    timer.current = setTimeout(() => onChange?.(meters), 450);
  };

  return (
    <div className="polygon-expansion">
      <div className="polygon-expansion__heading">
        <label htmlFor="polygon-expansion">Ampliar contorno</label>
        <output htmlFor="polygon-expansion">{localValue ? `+${localValue} m` : "Original"}</output>
      </div>
      <div className="polygon-expansion__row">
        <input
          id="polygon-expansion"
          type="range"
          className="radius-slider"
          min={0}
          max={MAX_POLYGON_EXPANSION_METERS}
          step={POLYGON_EXPANSION_STEP_METERS}
          value={localValue}
          disabled={disabled}
          aria-valuetext={localValue ? `${localValue} metros alrededor del contorno original` : "Contorno original"}
          title="Amplía todas las zonas por igual, hasta 1.000 metros"
          style={{ "--radius-fill": `${localValue / MAX_POLYGON_EXPANSION_METERS * 100}%` }}
          onChange={(event) => update(event.target.value)}
        />
        <button
          type="button"
          className="polygon-expansion__reset"
          disabled={disabled || localValue === 0}
          aria-label="Volver al polígono original"
          title="Volver al dibujo original"
          onClick={() => {
            clearTimeout(timer.current);
            setLocalValue(0);
            onChange?.(0);
          }}
        ><i className="pi pi-replay" aria-hidden="true" /></button>
      </div>
    </div>
  );
}
